import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { AccountTypes } from '../../enums/account-type';
import { MerchantOnboardingStatus } from '../../enums/merchant-onboarding-status';
import { Roles } from '../../enums/roles-enum';
import useAuth from '../../hooks/useAuth';

interface RequireAuthProps {
  allowedAccountType: string[];
  allowedOnboardingStatus: string[];
  allowedRoles: string[];
}

const RequireAuth = ({
  allowedAccountType,
  allowedOnboardingStatus,
  allowedRoles,
}: RequireAuthProps) => {
  const { auth } = useAuth();
  const location = useLocation();

  if (
    auth?.type &&
    allowedAccountType?.includes(auth?.type) &&
    auth?.onboardingStatus &&
    allowedOnboardingStatus?.includes(auth?.onboardingStatus) &&
    auth?.role &&
    allowedRoles?.includes(auth?.role)
  ) {
    return <Outlet />;
  } else if (
    auth?.role === Roles.ADMINISTRATOR ||
    auth?.role === Roles.SETTLEMENT ||
    auth?.role === Roles.CHECKER
  ) {
    return <Navigate to='/admin' state={{ from: location }} replace />;
  } else if (
    (auth?.role === Roles.MERCHANT ||
      auth?.role === Roles.PARTNER ||
      auth?.role === Roles.RESELLER ||
      auth?.role === Roles.MERCHANT_BRANCH) &&
    (auth?.type === AccountTypes.MERCHANT_BRANCH ||
      auth?.type === AccountTypes.PARTNER ||
      auth?.type === AccountTypes.RESELLER ||
      auth?.type === AccountTypes.MERCHANT)
  ) {
    if (auth?.onboardingStatus === MerchantOnboardingStatus.NO_RECORD) {
      //  TODO return when account verification is ready
      // return (
      //   <Navigate
      //     to='account-verification'
      //     state={{ from: location }}
      //     replace
      //   />
      // );
      return (
        <Navigate
          to='/onboarding/activate'
          state={{ from: location }}
          replace
        />
      );
    } else if (
      auth?.onboardingStatus === MerchantOnboardingStatus.NEW ||
      auth?.onboardingStatus === MerchantOnboardingStatus.PENDING
    ) {
      return (
        <Navigate to='/onboarding/pending' state={{ from: location }} replace />
      );
    } else if (auth?.onboardingStatus === MerchantOnboardingStatus.DECLINED) {
      return (
        <Navigate
          to='/onboarding/declined'
          state={{ from: location }}
          replace
        />
      );
    } else if (auth?.onboardingStatus === MerchantOnboardingStatus.APPROVED) {
      if (auth?.role === Roles.PARTNER && auth?.type === AccountTypes.PARTNER) {
        return (
          <Navigate
            to='/partner/dashboard'
            state={{ from: location }}
            replace
          />
        );
      } else if (
        auth?.role === Roles.RESELLER &&
        auth?.type === AccountTypes.RESELLER
      ) {
        return (
          <Navigate
            to='/reseller/dashboard'
            state={{ from: location }}
            replace
          />
        );
      } else if (
        auth?.role === Roles.MERCHANT &&
        auth?.type === AccountTypes.MERCHANT
      ) {
        return (
          <Navigate
            to='/merchant/dashboard'
            state={{ from: location }}
            replace
          />
        );
      } else if (
        auth?.role === Roles.MERCHANT_BRANCH &&
        auth?.type === AccountTypes.MERCHANT_BRANCH
      ) {
        return (
          <Navigate
            to='/branches/dashboard'
            state={{ from: location }}
            replace
          />
        );
      } else {
        return (
          <Navigate to='/unauthorized' state={{ from: location }} replace />
        );
      }
    } else {
      return <Navigate to='/unauthorized' state={{ from: location }} replace />;
    }
  } else if (
    !auth?.accessToken &&
    (location.pathname.includes('login') ||
      location.pathname.includes('register') ||
      location.pathname.includes('forgot-password') ||
      location.pathname.includes('reset-password'))
  ) {
    //allow redirect if really not logged in
    return <Outlet />;
  } else if (auth?.accessToken) {
    return <Navigate to='/unauthorized' state={{ from: location }} replace />;
  } else {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }
};

export default RequireAuth;
